$('.scroll_to').on('click', function(e) {
    var href = $(this).attr('href');
    if ($(href).length > 0) {
        var targetTop          = $(href).offset().top;
        var stickyNav          = $('#prospectus_sticky_nav');
        var stickyHeaderHeight = $('#sticky_header').outerHeight();
        var stuckHeight        = stickyNav.outerHeight() + stickyHeaderHeight;

        // scroll target - sticky navigation
        var scrollTo           = targetTop - stuckHeight;

        // prevent default action
        e.preventDefault();

        // scroll to item
        $('html, body').animate({
            scrollTop: scrollTo,
        }, 700, function() {
            $(href).focus();
        });
    }
});
